import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

// Lencana dock kanan + ringkasan misi untuk pemegang KTW: Surat (belum dibaca + permintaan teman), Kabar (baru), Misi (n/10).
// Cek saat buka + tiap 45 dtk; disegarkan saat sheet Surat/Kabar/Misi ditutup atau lewat segarkan().
export function useLencanaDock(token, sheet) {
  const [n, setN] = useState({ surat: 0, kabar: 0, misi: null });
  const tutup = sheet === "surat" || sheet === "kabar" || sheet === "misi";
  const cek = useCallback(() => {
    if (!token) return;
    Promise.allSettled([api.suratRingkas(token), api.kabarRingkas(token), api.misiRingkas(token)]).then(([s, k, m]) => {
      setN({ surat: s.status === "fulfilled" ? (s.value.belum_dibaca || 0) + (s.value.permintaan || 0) : 0, kabar: k.status === "fulfilled" ? k.value.baru || 0 : 0, misi: m.status === "fulfilled" ? m.value : null });
    });
  }, [token]);
  useEffect(() => {
    if (!token) { setN({ surat: 0, kabar: 0, misi: null }); return undefined; }
    cek();
    const t = setInterval(cek, 45000);
    return () => clearInterval(t);
  }, [token, tutup, cek]);
  return { ...n, segarkan: cek };
}
